module.exports = {
      id: "cross-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.488ce034.svg#cross-usage",
      toString: function () {
        return this.url;
      }
    }